<template>
  <v-container class="areas-section mx-2" fluid>
    <div class="areas-section__header">
      <v-icon color="primary" class="areas-section__header-icon">mdi-home-city-outline</v-icon>
      <h1 class="areas-section__title">{{ $route.meta.title }}</h1>
    </div>

    <template v-if="visibleTabs.length">
      <div class="areas-section__tabs-wrap mt-3">
        <v-tabs v-model="activeTab" class="areas-section__tabs" grow show-arrows="mobile">
          <v-tab
            v-for="tab in visibleTabs"
            :key="tab.key"
            class="areas-section__tab"
          >
            <v-icon v-if="tab.icon" left small>{{ tab.icon }}</v-icon>
            {{ tab.name }}
          </v-tab>
        </v-tabs>
      </div>

      <v-tabs-items v-model="activeTab" class="areas-section__tabs-items">
        <v-tab-item
          v-for="tab in visibleTabs"
          :key="tab.key"
        >
          <v-card class="areas-section__card" flat outlined>
            <component :is="tab.component" />
          </v-card>
        </v-tab-item>
      </v-tabs-items>
    </template>

    <v-card v-else class="areas-section__card pa-6 mt-3" flat outlined>
      <div class="text-center grey--text">
        Нет доступных подразделов в разделе «Районы».
      </div>
    </v-card>
  </v-container>
</template>

<script>
import ServiceAreasList from '@/components/areas/ServiceAreasList';
import MtoSectorsList from '@/components/areas/MtoSectorsList';
import RegionsList from '@/components/areas/RegionsList';

const TAB_DEFINITIONS = [
  {
    key: 'service-areas',
    name: 'Районы обслуживания',
    icon: 'mdi-map-marker-multiple',
    component: ServiceAreasList,
    permission: 'view_service_areas',
  },
  {
    key: 'mto-sectors',
    name: 'Участки МТО',
    icon: 'mdi-map-marker-radius',
    component: MtoSectorsList,
    permission: 'view_mto_sectors',
  },
  {
    key: 'regions',
    name: 'Районы',
    icon: 'mdi-city-variant-outline',
    component: RegionsList,
    permission: 'view_regions',
  },
];

export default {
  name: 'Areas',
  data () {
    return {
      activeTab: 0,
    };
  },
  computed: {
    tabs () {
      return TAB_DEFINITIONS.map(tab => ({
        ...tab,
        show: this.$checkPermission(tab.permission),
      }));
    },
    visibleTabs () {
      return this.tabs.filter(tab => tab.show);
    },
  },
  watch: {
    '$route.query.tab': {
      immediate: true,
      handler (tabKey) {
        this.syncTabFromQuery(tabKey);
      },
    },
    visibleTabs: {
      immediate: true,
      handler () {
        this.syncTabFromQuery(this.$route.query.tab);
      },
    },
    activeTab (index) {
      const tab = this.visibleTabs[index];
      if (!tab) return;

      const queryTab = this.$route.query.tab;
      if (queryTab !== tab.key) {
        this.$router.replace({ query: { ...this.$route.query, tab: tab.key } }).catch(() => {});
      }
    },
  },
  methods: {
    syncTabFromQuery (tabKey) {
      if (!this.visibleTabs.length) {
        this.activeTab = 0;
        return;
      }

      if (tabKey) {
        const index = this.visibleTabs.findIndex(tab => tab.key === tabKey);
        if (index >= 0) {
          this.activeTab = index;
          return;
        }

        const legacyIndex = parseInt(tabKey, 10);
        if (!Number.isNaN(legacyIndex) && legacyIndex < this.visibleTabs.length) {
          this.activeTab = legacyIndex;
          return;
        }
      }

      if (this.activeTab >= this.visibleTabs.length) {
        this.activeTab = 0;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.areas-section__header {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 0;
}

.areas-section__title {
  font-size: 1.5rem;
  font-weight: 500;
  color: #37474f;
  margin: 0;
}

.areas-section__tabs-wrap {
  background: #fff;
  border: 1px solid rgba(0, 0, 0, 0.12);
  border-radius: 12px 12px 0 0;
  border-bottom: none;
  overflow: hidden;
}

.areas-section__tabs {
  box-shadow: none;
}

.areas-section__tabs ::v-deep .v-tabs-bar {
  background: transparent;
  height: 48px;
}

.areas-section__tab {
  text-transform: none;
  font-size: 0.9375rem;
  font-weight: 500;
  color: #546e7a;
  min-height: 48px;
}

.areas-section__tabs ::v-deep .v-tab--active {
  color: #1976d2;
}

.areas-section__tabs ::v-deep .v-tabs-slider {
  color: #1976d2;
  height: 3px;
}

.areas-section__tabs-items {
  background: transparent;
}

.areas-section__card {
  border-radius: 0 0 12px 12px;
  overflow: hidden;
  border: 1px solid rgba(0, 0, 0, 0.12);
  border-top: none;
}
</style>
